<template>
  <div>
    <v-card class="mx-auto" height="350">
      <v-card-title>
        <v-tabs
            v-model="tab"
            background-color="transparent"
            color="basil"
            grow
        >
          <v-tab
              v-for="(item,index) in heroInfo.summary.opponent"
              :key="index"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>

      </v-card-title>
      <v-divider></v-divider>
      <div class="px-2 py-3">
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="(t,i) in heroInfo.summary.opponent"
              :key="i"
          >
            <div v-for="(item,index) in t.list.slice(0,3)" :key="index" class="opponent-class my-6">

              <div class="opponent-index-class text-h5">
                {{ index + 1 }}
              </div>


              <div class="opponent-avatar-class">
                <v-avatar>
                  <img
                      :src="item.img"
                      alt=""
                  >
                </v-avatar>
              </div>

              <div class="opponent-progress-liner-class">
                <v-progress-linear
                    :value="item.winRate"
                    color="#1dbaa9"
                    height="25"
                >
                  <strong>{{ item.winRate }}%</strong>
                </v-progress-linear>
              </div>

              <div class="opponent-name-class">
                {{ item.name }}
              </div>

            </div>

          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Opponent",
  props: {
    heroInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    tab: null,
  })
}
</script>

<style scoped>
.opponent-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.opponent-index-class {
  width: 5%;
  text-align: right;
}

.opponent-avatar-class {
  width: 20%;
  display: flex;
  justify-content: center;
}


.opponent-progress-liner-class {
  width: 50%;
}

.opponent-name-class {
  text-align: center;
  width: 20%;
}
</style>
